export default "__VITE_ASSET__C8FWT0q$__"